<template>
    <div class="basic-modal container">
        <div v-if="type == 'input'">
            <amf-input v-model="value" :label="text" :validator="$v.value" show-label :columns="3"/>
        </div>

        <div v-else-if="type == 'select'" class="mb-3">
            <amf-select v-model="value" :label="text" :validator="$v.value" :options="options" show-label :columns="3"/>
        </div>

        <div v-else-if="type == 'multiLineInput'" class="mb-3">
            <amf-textarea v-model="value" :label="text" :validator="$v.value" :show-label="false" :columns="3"/>
        </div>

        <div v-else-if="type == 'multiSelect'" class="mb-3">
            <amf-multiple-select v-model="value" :label="text" show-label  :options="options" :validator="$v.value" mapName="name" :columns="3"/>
        </div>

        <div v-else-if="type == 'passphrase'" class="mb-3">
            <div class="d-flex flex-row justify-content-center align-items-stretch py-2">
                {{ formattedText }}
            </div>
            <div class="d-flex flex-row justify-content-center align-items-stretch py-2">
                To continue please answer the following prompt
            </div>
            <div class="d-flex flex-row justify-content-center align-items-stretch py-2">
                <amf-input v-model="value" :label="passphraseDescription" :validator="$v.value" show-label :columns="3"/>
            </div>
        </div>

        <div v-else class="d-flex flex-row justify-content-center align-items-stretch py-2" style="overflow: auto; max-height: 500px;">
            <div v-html="formattedText"></div>
        </div>

    </div>
</template>

<script>
import { v } from "framework";

let config = {
    confirm: {
        title: "Confirm",
        buttons: "Confirm/Cancel",
    },
    passphrase: {
        title: "Confirm",
        buttons: "Confirm/Cancel"
    },
    info: {
        title: "Information",
        buttons: "*Close",
    },
    discard: {
        title: "Discard Changes",
        buttons: "Discard/Cancel",
    },
    input: {
        title: "Input",
        buttons: "OK/Cancel"
    },
    multiLineInput: {
        title: "Input",
        buttons: "OK/Cancel"
    },
    multiSelect: {
        title: "Input",
        buttons: "OK/Cancel"
    },
    select: {
        title: "Input",
        buttons: "OK/Cancel"
    }
}

export default {
  props: ["type", "customTitle", "text", "initialValue", "options", "buttonsCustom", "validation", "passphrase", "passphraseDescription"],
  data() {
    return {
        value: this.initialValue
    };
  },
  computed: {
      buttons() {
        return config[this.type].buttons;
      },
      height() { return 200; },
      formattedText() {
        return this.text.split('//').join("<br />");
        },
      title() { return this.customTitle ? this.customTitle : config[this.type].title; },
  },
  methods: {
        async confirm() {
            return this.type == 'confirm'
                || (this.type == 'passphrase' && this.value == this.passphrase);
        },
        async ok() {
            if (this.type == "input" || this.type == "multiLineInput" || this.type =="multiSelect" || this.type == "select") {
                return this.value;
            } else {
                return true;
            }
        },
        async discard() { return true; }
  },
  validations() {
      return {
          value: this.validation ? this.validation() : v.build(v.required(), v.custom(x => {
            if(this.type != 'passphrase') return true;

            return this.value == this.passphrase;
          }, "The prompt is incorrect")),
      }
  }
};

</script>

<style lang="scss" scoped>
    .basic-modal {
        font-size: 108%;
    }
</style>



// WEBPACK FOOTER //
// src/framework/primitives/BasicModal.vue